var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.258 2.832l7.12 7.12a.88.88 0 001.244 0l7.12-7.12a.88.88 0 000-1.244l-.83-.83A.88.88 0 0013.67.756L8 6.4 2.33.756a.88.88 0 00-1.242.002l-.83.83a.88.88 0 000 1.244z","fillRule":"evenodd"}));
}

ChevronDown.defaultProps = {"viewBox":"0 0 16 11"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
